import React from 'react';

const OrganizationSettingsPage: React.FC = () => <div>Organization settings</div>;

export default OrganizationSettingsPage;
